import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.#toggleDarkMode(this.element.dataset.darkMode === "true")
  }

  #toggleDarkMode(darkMode) {
    if (darkMode) {
      document.body.classList.add("artemis-body-dark", "dark")
      document.body.classList.remove("artemis-body-light")
    } else {
      document.body.classList.remove("artemis-body-dark", "dark")
      document.body.classList.add("artemis-body-light")
    }

    // Dispatch custom event so existing charts can re-render if needed
    window.dispatchEvent(new CustomEvent("dark-mode-changed", { detail: { darkMode } }))
  }
}
